

const scrollTableDelay = function (el) {
    console.log(el.firstElementChild.innerHTML);
    let offsetHeight = el.offsetHeight;
    let timer = null;
    let scrollHeight = el.firstElementChild.scrollHeight;
    let childHeight = el.getElementsByTagName("li")[0].offsetHeight;
    let len = el.getElementsByTagName("li").length * 2;
    let num = 4;
    // 如果当前可滚动的高度小于外层容器高度。就不进行滚动
    if (scrollHeight <= offsetHeight) {
        return false;
    }
  
    el.firstElementChild.innerHTML = el.firstElementChild.innerHTML + el.firstElementChild.innerHTML;
    function clearClass() {
        for (var i=0; i< el.getElementsByTagName("li").length; i++){
            el.getElementsByTagName("li")[i].className = "";
        }
    }

    function bindScroll() {
       
       
        timer = setInterval(() => {
            let curr_top = childHeight;
            if (num > len/2) {
                num = 4;
                clearClass();
                el.scrollTop = 0;
                el.getElementsByTagName("li")[num-1].className += ' prev';
                el.getElementsByTagName("li")[num].className += ' active';
                el.getElementsByTagName("li")[num+1].className += ' prev';
            }
            let time_id = setInterval(()=>{
                el.scrollTop++;
                curr_top--;
                clearClass();
                if(curr_top <= 0){
                    num++;
                    clearInterval(time_id);
                    el.getElementsByTagName("li")[num-1].className += ' prev';
                    el.getElementsByTagName("li")[num].className += ' active';
                    if (num+1 < len) {
                        el.getElementsByTagName("li")[num+1].className += ' prev';
                    }
                }
            } , 5);
        }, 3000);
    }
    bindScroll();
    el.addEventListener("mouseover", function () {
        clearInterval(timer);
    }, { passive: true });

    el.addEventListener("mouseleave", function () {
        bindScroll();
    }, { passive: true });

};

export default scrollTableDelay;